module.exports = __webpack_public_path__ + "assets/0aa4469291095aa7246a9e0c1034e778.png";